import { render } from "./wInputSuggest2.vue?vue&type=template&id=0de5640c&ts=true"
import script from "./wInputSuggest2.vue?vue&type=script&lang=ts"
export * from "./wInputSuggest2.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__